import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Output } from '@angular/core';
import { HttpEventType, HttpEvent } from "@angular/common/http";
import { FIREBASE_OPTIONS } from '@angular/fire/compat';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ServerAuthService } from '@app/shared/_services/server-auth.service';
import { SigninStrategyService } from '@app/shared/_services/signin-strategy.service';
import { UserAuthService } from '@app/shared/_services/user-auth.service';
import { environment } from '@env/environment';
import { ApiClientService } from "@shared/_services/api-client.service";
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { NgxPaginationModule } from "ngx-pagination";
import Swal from "sweetalert2";
import { PreloaderComponent } from '@app/modules/utils/preloader/preloader.component';
import { RouterModule, ActivatedRoute, } from '@angular/router';
import { SearchService } from '@app/shared/_services/search.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-admin-users',
  standalone: true,
  imports: [CommonModule, FormsModule, ToastrModule, NgxPaginationModule, PreloaderComponent, RouterModule],
  providers: [
    // { provide: "API_BASE_URL", useValue: environment.apiUrl },
    { provide: FIREBASE_OPTIONS, useValue: environment.firebase },
    AngularFireAuth,
    SigninStrategyService,
    ServerAuthService,
    UserAuthService,
    ToastrService,
  ],
  templateUrl: './admin-users.component.html',
  styleUrl: './admin-users.component.css'
})
export class AdminUsersComponent {
  public searchQuery: string = '';

  public loading: boolean = false;
  public hasError: boolean = false;
  public errorMsg: string = '';
  public users: any[] = [];
  public admins: any = [];
  public totalItems: number = 0;
  public currentPage: number = 1;
  public pageSize: number = 10;

  constructor(private _apiClientService: ApiClientService, 
              private _toastrService: ToastrService,
              private _searchService: SearchService,
              private route: ActivatedRoute,
            ) { }

  ngOnInit() {
        this.getAllUsers();

    this.route.queryParams.subscribe(params => {
      const searchTerm = params['search'];
      if (searchTerm) {
        this.searchQuery = searchTerm;
        this.onSearch(searchTerm);
      } else {
        this.searchQuery = '';
        this.getAllUsers();
      }
    });
  }

  onSearch(term: string) {
    console.log("termed",term);
    if (term && term.trim() !== '') {
      this.loading = true;
      this.hasError = false;
      this.errorMsg = '';
      this.searchQuery = term;
      this.currentPage = 1;

      this._searchService.searchAdmin(term.trim()).subscribe({
        next: (users: any[]) => {
          this.loading = false;
          this.users = users;
          this.totalItems = users.length;
        },
        error: (error) => {
          this.loading = false;
          this.hasError = true;
          this.errorMsg = error?.message || 'Something went wrong during search.';
        }
      });
    } else {
      this.getAllUsers();
    }
  }

onSearchInputChanged()  {
  const trimmed = this.searchQuery.trim();
  if (trimmed === '') {
    this.getAllUsers();
  }
}

  public async getAllUsers() {
    this.loading = true;
    (await this._apiClientService.readAllApiService(`admin/admin-user?page=${this.currentPage}&pageSize=${this.pageSize}`)).subscribe(
      (event: HttpEvent<any>): any => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.loading = true;
            break;
          case HttpEventType.Response:
            this.loading = false;
            console.log("Users Details ", event.body);
            let { status, error, message, data, totalPages, count } = event.body;
            //if (status == 200) {

            this.totalItems = count;
            this.users = data;
          // } else {
          //   this.hasError = true;
          //   this.errorMsg = 'something went wrong please contact Technical Support';
          // }
        }
      },
      (errorObj: any) => {
        this.loading = false;
        const errorMsg = errorObj?.error?.Message;
        this.hasError = true;
        this.errorMsg = errorMsg || 'something went wrong please contact Technical Support';
      }
    );
  }



  private compare(a: any, b: any): any {
    const bandA = a.order;
    const bandB = b.order;

    let comparison = 0;
    if (bandA > bandB) {
      comparison = 1;
    } else if (bandA < bandB) {
      comparison = -1;
    }
    return comparison;
  }

  public async addUser(region: any) {
    this.loading = true;
    (await this._apiClientService.addApiService('region', region)).subscribe(
      (event: HttpEvent<any>): any => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.loading = true;
            break;
          case HttpEventType.Response:
            this.loading = false;
            console.log("User Added ", event.body);
            let { status, error, message, data } = event.body;
            this._toastrService.success('Success', 'Added User Successfully');
            //if (status == 200) {
            this.getAllUsers();
          // } else {
          //   this.hasError = true;
          //   this.errorMsg = 'something went wrong please contact Technical Support';
          // }
        }
      },
      (errorObj: any) => {
        this.loading = false;
        const errorMsg = errorObj?.error?.Message;
        this.hasError = true;
        this.errorMsg = errorMsg || 'something went wrong please contact Technical Support';
      }
    );
  }

  public async updateUser(region: any) {
    this.loading = true;
    (await this._apiClientService.updateApiService(`region`, region.id, region)).subscribe(
      (event: HttpEvent<any>): any => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.loading = true;
            break;
          case HttpEventType.Response:
            this.loading = false;
            console.log("User Updated ", event.body);
            this._toastrService.success('Success', 'Updated User Successfully');
            let { status, error, message, data } = event.body;
            //if (status == 200) {
            this.getAllUsers();
          // } else {
          //   this.hasError = true;
          //   this.errorMsg = 'something went wrong please contact Technical Support';
          // }
        }
      },
      (errorObj: any) => {
        this.loading = false;
        const errorMsg = errorObj?.error?.Message;
        this.hasError = true;
        this.errorMsg = errorMsg || 'something went wrong please contact Technical Support';
      }
    );
  }

  public async deleteUser(adminUser: any) {
    this.loading = true;
    (await this._apiClientService.addApiService(`admin/admin-user/remove`, { userId: adminUser._id })).subscribe(
      (event: HttpEvent<any>): any => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.loading = true;
            break;
          case HttpEventType.Response:
            this.loading = false;
            console.log("Region Deleted ", event.body);
            this._toastrService.success('Removed admin user successfully', 'Success');
            let { status, error, message, data } = event.body;
            //if (status == 200) {
            this.getAllUsers();
          // } else {
          //   this.hasError = true;
          //   this.errorMsg = 'something went wrong please contact Technical Support';
          // }
        }
      },
      (errorObj: any) => {
        this.loading = false;
        const errorMsg = errorObj?.error?.Message;
        this.hasError = true;
        this.errorMsg = errorMsg || 'something went wrong please contact Technical Support';
      }
    );
  }

  triggerDelete(adminUser: any) {
    console.log(adminUser);
    const self = this;
    Swal.fire({
      title: 'Remove Admin User',
      text: 'Do you want to remove this admin user?',
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonColor: '#dc3545', // Green color for Yes button
      cancelButtonColor: '#9b9b9b',  // Red color for No button
    }).then((result: any) => {
      /* Read more about isConfirmed, isDenied below */
      console.log(result.isConfirmed);
      if (result.isConfirmed) {
        console.log(result);
        this.deleteUser(adminUser);
      }
    });
  }

  public renderPage(event: number) {
    window.scroll(0, 0);
    this.currentPage = event;
    this.getAllUsers();
  }

}
